import { configDotenv } from "dotenv"
import mixpanel from '@utils/mixpanel/mixpanel.js';
configDotenv()
export const baseUrl = process.env.REACT_APP_API_BASE_URL 
export const isLocal = process.env.REACT_APP_IS_LOCAL === 'true'
export const socketUrl = process.env.REACT_APP_CHAT_URL;
export const connectSocket = process.env.REACT_APP_CONNECT_SOCKET === 'true';

